var borders_default = {
  "borderT": "_61ICN",
  "borderB": "x0-as",
  "borderL": "-seKt",
  "borderR": "-H-bS"
};
export {
  borders_default as default
};
//# sourceMappingURL=borders-scss.js.map
